import script from "./SignatureList.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureList.vue?vue&type=script&setup=true&lang=js"

import "./SignatureList.vue?vue&type=style&index=0&id=e3620236&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3620236"]])

export default __exports__